import type { SkeletonConfig } from "./skeletonTypes";

export const QUANTIZE_EPSILON = 0.000001;
export const DEFAULT_CONFIG: SkeletonConfig = {};
export const DEBUG_CONFIG: SkeletonConfig = {
  iterationLimit: 1000,
  debug: {
    log: [],
    text: [],
    points: [],
    lines: [],
  },
};
